module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Saucepan-a9b548b2ce41308a0b29369f4192b1bf.svg";